import IoaWorkbenchError from './IoaWorkbenchError';
import ObjectUtils from '../utils/ObjectUtils';

export default class ServiceError extends IoaWorkbenchError {
  constructor(cause) {
    const s = ObjectUtils.isString(cause) ? cause : cause.message;
    super(`ServiceError: There was an error calling a remote service: ${s}`);
  }
}
